export const SERVICE_UNAVAILABLE_STATUS = 503;

export const SERVICE_UNAVAILABLE_MESSAGE =
  "Our system is currently unavailable. Please check back soon.";

let isUnavailable = false;
const listeners = new Set<() => void>();

const setServiceUnavailable = (value: boolean): void => {
  if (isUnavailable === value) return;
  isUnavailable = value;
  listeners.forEach((listener) => listener());
};

export const isServiceUnavailableStatus = (status?: number): boolean =>
  status === SERVICE_UNAVAILABLE_STATUS;

// Called from the API layer whenever the backend answers with a 503, so any
// part of the widget can react without every caller handling the status.
export const notifyServiceUnavailable = (): void => setServiceUnavailable(true);

// Called after a successful API call, so the widget recovers once the backend
// comes back instead of staying stuck until the page is reloaded.
export const clearServiceUnavailable = (): void => setServiceUnavailable(false);

export const getServiceUnavailable = (): boolean => isUnavailable;

export const subscribeToServiceUnavailable = (
  listener: () => void
): (() => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};
